





define([
    'rest/request/matrixFactory',
    'rest/request/requestFactory',
    'endpoints',
    'apiKeyNames'
],
function(matrixFactory, requestFactory, endpoints, ApiKeyNames) {
    'use strict';

    var maxNoOfElementsInBatchRequest = 100,
        routingKeyName = ApiKeyNames.routing;

    return function() {
        return {
            calculateRoute: requestFactory.single(endpoints.routing, routingKeyName),

            calculateReachableRange: requestFactory.single(endpoints.reachableRange, routingKeyName),

            batch: requestFactory.batch(maxNoOfElementsInBatchRequest, {
                batchSync: endpoints.batchSyncRouting,
                batch: endpoints.batchRouting,
                single: endpoints.batchRoutingQuery
            }, routingKeyName),

            batchReachableRange: requestFactory.batch(maxNoOfElementsInBatchRequest, {
                batchSync: endpoints.batchSyncRouting,
                batch: endpoints.batchRouting,
                single: endpoints.batchReachableRangeQuery
            }, routingKeyName),

            matrix: matrixFactory(maxNoOfElementsInBatchRequest)
        };
    };
});



// WEBPACK FOOTER //
// ./rest/routing.js